let host = document.location.host;
let apiUrl = 'https://api.coachrightusa.com/';
const environment = {
  api: apiUrl,
};
export default environment;
